import axios from "axios";

export default function updateAdminStatus({ uuid, isEnabled }) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/account/system-admin/api/v1/admin/${uuid}/status`, {
        enabled: isEnabled,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
